export const SERVER_ERROR_TYPES = {
  missingPermissions: "missing-required-permissions",
};
